import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @file Created on Mon Aug 06 2018
 * @author VBr
 */


import { CompetitorPrice } from '@logio/common-be-fe';
import { List } from 'immutable';
import { action, observable, runInAction } from 'mobx';
import { CompetitorPriceLayer } from '../../transportLayers/data-cleaning/CompetitorPriceLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * This store obtaining data of price zones.
 */

export var CompetitorPriceStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(CompetitorPriceStore, _BaseStore);

  function CompetitorPriceStore() {
    var _this;

    _classCallCheck(this, CompetitorPriceStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceStore).apply(this, arguments));
    _this.name = StoreName.CompetitorPrice;
    _this.competitorPriceLayer = new CompetitorPriceLayer();
    _this.priceHistoryIndexes = new Map();
    _this.internalProductsMap = new Map();
    _this.agencyQualityEvaluations = [];
    _this.missingCompetitorPrices = [];
    _this.modifiedPrices = new Map();
    return _this;
  }

  _createClass(CompetitorPriceStore, [{
    key: "getCompetitorPricesInZone",
    value: function getCompetitorPricesInZone(internalProductId, priceZoneId, competitorId) {
      var _this2 = this;

      this.internalProductsMap.clear();
      return this.competitorPriceLayer.getCompetitorPricesInZone(internalProductId, priceZoneId, competitorId).then(function (competitorPrices) {
        runInAction(function () {
          var prices = List();
          competitorPrices.forEach(function (price) {
            prices = prices.push(price);
          });
          _this2.internalProductsMap = _this2.internalProductsMap.set(internalProductId, prices);
        });
        return competitorPrices;
      });
    }
  }, {
    key: "getMissingCompetitorPrices",
    value: function getMissingCompetitorPrices(productId, numberOfWeeks) {
      var _this3 = this;

      return this.competitorPriceLayer.getMissingCompetitorPrices(productId, numberOfWeeks).then(function (missingCompetitorPrices) {
        var list = [];
        missingCompetitorPrices.forEach(function (missingPrices) {
          var competitorMap = new Map();
          Object.keys(missingPrices).forEach(function (key) {
            competitorMap.set(key, missingPrices[key]);
          });
          list.push(competitorMap);
        });
        runInAction(function () {
          _this3.missingCompetitorPrices = list;
        });
      });
    }
  }, {
    key: "getAgencyQualityEvaluations",
    value: function getAgencyQualityEvaluations() {
      var _this4 = this;

      return this.competitorPriceLayer.getAgencyQualityEvaluations().then(function (agencyQualityEvaluations) {
        runInAction(function () {
          _this4.agencyQualityEvaluations = agencyQualityEvaluations;
        });
      });
    }
  }, {
    key: "updateCompetitorPrice",
    value: function updateCompetitorPrice(internalProductId, competitorPrice) {
      var _this5 = this;

      return this.competitorPriceLayer.updateCompetitorPrice(competitorPrice).then(function (price) {
        var priceIndex = _this5.internalProductsMap.get(internalProductId).findIndex(function (cp) {
          return cp.id === price.id;
        });

        runInAction(function () {
          _this5.internalProductsMap.set(internalProductId, _this5.internalProductsMap.get(internalProductId).set(priceIndex, price));
        });
      });
    }
  }, {
    key: "getCompetitorPriceHistoryIndexes",
    value: function getCompetitorPriceHistoryIndexes(competitorPriceIds, zoneId) {
      var _this6 = this;

      this.priceHistoryIndexes.clear();
      return this.competitorPriceLayer.getCompetitorPriceHistoryIndexes(competitorPriceIds, zoneId).then(function (competitorPriceHistoryIndexes) {
        runInAction(function () {
          competitorPriceHistoryIndexes.forEach(function (priceHistoryIndex) {
            _this6.priceHistoryIndexes.set(priceHistoryIndex.competitorPriceId, priceHistoryIndex);
          });
        });
      });
    }
  }, {
    key: "getModifiedPrices",
    value: function getModifiedPrices(competitorPriceIds) {
      var _this7 = this;

      this.modifiedPrices.clear();
      return this.competitorPriceLayer.getModifiedPrices(competitorPriceIds).then(function (competitorModifiedPrices) {
        runInAction(function () {
          competitorModifiedPrices.forEach(function (price) {
            _this7.modifiedPrices.set(price.competitorPriceId, price);
          });
        });
      });
    }
  }]);

  return CompetitorPriceStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], CompetitorPriceStore.prototype, "priceHistoryIndexes", void 0);

__decorate([observable, __metadata("design:type", Map)], CompetitorPriceStore.prototype, "internalProductsMap", void 0);

__decorate([observable, __metadata("design:type", Array)], CompetitorPriceStore.prototype, "agencyQualityEvaluations", void 0);

__decorate([observable, __metadata("design:type", Array)], CompetitorPriceStore.prototype, "missingCompetitorPrices", void 0);

__decorate([observable, __metadata("design:type", Map)], CompetitorPriceStore.prototype, "modifiedPrices", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object, Object, Object]), __metadata("design:returntype", Promise)], CompetitorPriceStore.prototype, "getCompetitorPricesInZone", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object, Number]), __metadata("design:returntype", Promise)], CompetitorPriceStore.prototype, "getMissingCompetitorPrices", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], CompetitorPriceStore.prototype, "getAgencyQualityEvaluations", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String, CompetitorPrice]), __metadata("design:returntype", void 0)], CompetitorPriceStore.prototype, "updateCompetitorPrice", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array, String]), __metadata("design:returntype", Promise)], CompetitorPriceStore.prototype, "getCompetitorPriceHistoryIndexes", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", Promise)], CompetitorPriceStore.prototype, "getModifiedPrices", null);